export default class Coordinates {
  latitude: number
  longitude: number

  get exists() {
    return this.latitude !== 0 && this.longitude !== 0
  }

  constructor(data: Record<string, unknown> | null | undefined) {
    if (data) {
      this.latitude = (data.latitude as number) ?? 0
      this.longitude = (data.longitude as number) ?? 0
    } else {
      this.latitude = 0
      this.longitude = 0
    }
  }
}
